/* eslint-disable no-unused-vars */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, {
    useState, useEffect, useCallback, useContext, useRef,
} from 'react';
import { Link, useParams } from 'react-router-dom';
import { PriceHandler, TitleCase } from '../../../redux/helper/CamelCase';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import AreaListSkeleton from './AreaListSkeleton';
import HeaderContext from '../../../Components/Context/HeaderContext';

function ViewAreaWiseReport() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const { id } = useParams();
    const [areawiseList, setAreawiseList] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [areaSelected, setArea] = useState('');
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage]);

    const handleFetchView = useCallback((() => {
        distributorService.MISAreaWiseCustomerOutstandingReport(id, currentPage, debouncedSearch).then((areawise) => {
            if (!areawise.error && areawise.data.success_status === true) {
                if (Object.keys(areawise.data.data).length === 0) {
                    setEmptyData(true);
                    setLoading(false);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setArea(areawise.data.area);
                setAreawiseList(areawise.data.data);
                setTotalPage(areawise.data.number_of_pages);
                setalldata(areawise.data.data);
                setCurrentPage(areawise.data.current_page);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [id, currentPage, debouncedSearch]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleExport = useCallback((() => {
        distributorService.MISAreaWiseCustomerOutstandingReport(id, currentPage, debouncedSearch, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchView();
    }, [handleFetchView]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <div className="flex items-center">
                    <Link to="/mis-reports/area-wise-customer-outstanding-report">
                        <img src="/images/arrow-back-fill.svg" alt="icon" />
                    </Link>
                    <h5 className="text-xs4 font-normal text-[#555259] ml-3">
                        {TitleCase(areaSelected)}
                        {' '}
                        Customer’s Outstanding Report
                    </h5>
                </div>

                <div className="flex">
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[81px] ${exportClick === true ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    onClick={() => setexportSelected('pdf-converter')}
                                    href="#"
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}

                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <AreaListSkeleton /> : (
                <div>
                    {Object.keys(areawiseList).length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky left-0 top-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[250px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Unit
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg  bg-[#555259]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Outstanding Amount
                                                <a href="#" className="pl-[5px]">
                                                    <img src="images/Group-9083.svg" alt="" />
                                                </a>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(areawiseList).map((area) => (
                                        <>
                                            {area[1].items.map((item) => (
                                                <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                    <td
                                                        className="text-sm font-normal text-center text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4 z-[1]"
                                                        style={{
                                                            background: 'rgba(255, 255, 255, 0.45)',
                                                            backdropFilter: 'blur(5.5px)',
                                                        }}
                                                    >
                                                        {item?.PARTY_NAME}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                        {item.CUSTOMER_NO}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                        {item.ORGANIZATION_NAME}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                        {PriceHandler(item?.OUTSTANDING_AMOUNT_RS)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td
                                                    className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                />
                                                <td className="text-sm font-normal text-[#ED1C24] py-2.5 px-7 text-center">
                                                    Customer Total
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7" />
                                                <td className="text-sm font-normal text-[#ED1C24] py-2.5 px-7 text-center">
                                                    {PriceHandler(area[1].total)}
                                                </td>
                                            </tr>
                                        </>

                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && Object.keys(areawiseList).length > 0
                        && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                totalPage={totalPage}
                                List={alldata}
                                currentPage={currentPage}
                            />
                        )}
                </div>
            )}
            {emptyData && (
                <EmptyScreen
                    searchValue={searchValue}
                    text="no specific area wise Report"
                    buttonRequired={false}
                />
            )}

        </div>
    );
}

export default ViewAreaWiseReport;
